<footer class="footer">				
	<!-- Footer Top -->
	<div class="footer-top">
		<div class="container-fluid">
			<div class="row">
				<div class="col-lg-3 col-md-6">
				
					<!-- Footer Widget -->
					<div class="footer-widget footer-about">
						<div class="footer-logo">
							<img src="assets/img/footer-logo.png" alt="logo">
						</div>
						<div class="footer-about-content">
							<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. </p>
							<div class="social-icon">
								<ul>
									<li>
										<a href="javascript:void(0)" target="_blank"><i class="fab fa-facebook-f"></i> </a>
									</li>
									<li>
										<a href="javascript:void(0)" target="_blank"><i class="fab fa-twitter"></i> </a>
									</li>
									<li>
										<a href="javascript:void(0)" target="_blank"><i class="fab fa-linkedin-in"></i></a>
									</li>
									<li>
										<a href="javascript:void(0)" target="_blank"><i class="fab fa-instagram"></i></a>
									</li>
									<li>
										<a href="javascript:void(0)" target="_blank"><i class="fab fa-dribbble"></i> </a>
									</li>
								</ul>
							</div>
						</div>
					</div>
					<!-- /Footer Widget -->
					
				</div>
				
				<div class="col-lg-3 col-md-6">
				
					<!-- Footer Widget -->
					<div class="footer-widget footer-menu">
						<h2 class="footer-title">For Patients</h2>
						<ul>
							<li><a [routerLink]="'/patients/search-doctor'">Search for Doctors</a></li>
							<li><a [routerLink]="'/login'">Login</a></li>
							<li><a [routerLink]="'/Register'">Register</a></li>
							<li><a [routerLink]="'/patients/booking'">Booking</a></li>
							<li><a [routerLink]="'/patients/dashboard'">Patient Dashboard</a></li>
						</ul>
					</div>
					<!-- /Footer Widget -->
					
				</div>
				
				<div class="col-lg-3 col-md-6">
				
					<!-- Footer Widget -->
					<div class="footer-widget footer-menu">
						<h2 class="footer-title">For Doctors</h2>
						<ul>
							<li><a [routerLink]="'/doctor/appointment'">Appointments</a></li>
							<li><a  [routerLink]="'/doctor/message'">Chat</a></li>
							<li><a [routerLink]="'/login'">Login</a></li>
							<li><a [routerLink]="'/Register'">Register</a></li>
							<li><a [routerLink]="'/doctor/dashboard'">Doctor Dashboard</a></li>
						</ul>
					</div>
					<!-- /Footer Widget -->
					
				</div>
				
				<div class="col-lg-3 col-md-6">
				
					<!-- Footer Widget -->
					<div class="footer-widget footer-contact">
						<h2 class="footer-title">Contact Us</h2>
						<div class="footer-contact-info">
							<div class="footer-address">
								<span><i class="fas fa-map-marker-alt"></i></span>
								<p> 3556  Beech Street, San Francisco,<br> California, CA 94108 </p>
							</div>
							<p>
								<i class="fas fa-phone-alt"></i>
								+1 315 369 5943
							</p>
							<p class="mb-0">
								<i class="fas fa-envelope"></i>
								doccure@example.com
							</p>
						</div>
					</div>
					<!-- /Footer Widget -->
					
				</div>
				
			</div>
		</div>
	</div>
	<!-- /Footer Top -->
	
	<!-- Footer Bottom -->
	<div class="footer-bottom">
		<div class="container-fluid">
		
			<!-- Copyright -->
			<div class="copyright">
				<div class="row">
					<div class="col-md-6 col-lg-6">
						<div class="copyright-text">
							<p class="mb-0">© 2020 Doccure. All rights reserved.</p>
						</div>
					</div>
					<div class="col-md-6 col-lg-6">
					
						<!-- Copyright Menu -->
						<div class="copyright-menu">
							<ul class="policy-menu">
								<li><a [routerLink]="'/terms-conditions'">Terms and Conditions</a></li>
								<li><a [routerLink]="'/privacy-policy'">Policy</a></li>
							</ul>
						</div>
						<!-- /Copyright Menu -->
						
					</div>
				</div>
			</div>
			<!-- /Copyright -->
			
		</div>
	</div>
	<!-- /Footer Bottom -->	
</footer>